import { Injectable } from '@angular/core';
import { API_URL, OperationType } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { DataService } from '../../base-data-services/data.service';
import { environment } from 'src/environments/environment';
import { InternshipModel } from 'common/models/page-models/internship/internship/internship-data-model';

@Injectable()
export class InternshipSendInviteDataService extends DataService<InternshipModel> {
  constructor(protected ss: SystemService, protected http: SmApiService) {
    super(ss, API_URL.sendInviteToStudents, http);
  }

  createInstance(): InternshipModel {
    return new InternshipModel();
  }

  override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
    return environment.apiUrl + this.getAPI_URL();
  }
}